import { CONSTANTS, TelemetryService } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WebTelemetryService implements TelemetryService {
  public async userHasTelemetryEnabled(): Promise<boolean> {
    return localStorage.getItem(CONSTANTS.SAVE_TELEMETRY_KEY) === 'true';
  }
}
